import Splide from '@splidejs/splide'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'container' ]

  connect() {
    this.element.querySelectorAll('.splide__slide--clone').forEach(e => e.remove())
    this.slider = new Splide( this.containerTarget ).mount()
  }

  reload(e) {
    this.slider.refresh()
    const index = e.detail.param || 0
    this.slider.Components.Track.jump(parseInt(index))
  }
}
